import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck, ShieldQuestion } from "lucide-react";
import api from "@/lib/api";

export default function VerifyEstate() {
  const { prefix, id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/4thave/verify/${prefix}/${id}`)
      .then((r) => setData(r.data))
      .catch(() => setData({ activated: false, message: "This Domain Estate has not been activated." }))
      .finally(() => setLoading(false));
  }, [prefix, id]);

  return (
    <div className="min-h-screen bg-race-bg flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-race-surface border border-race-line rounded-lg p-8" data-testid="verify-estate-page">
        <div className="text-center mb-6">
          <div className="overline text-race-sub">www.4thAve.io</div>
          <div className="font-mono text-sm text-race-txt break-all mt-1">www.4thAve.io/{prefix}#{id}</div>
        </div>

        {loading ? (
          <p className="text-center text-race-sub">Checking the ledger…</p>
        ) : data?.activated ? (
          <div className="text-center" data-testid="verify-activated">
            <ShieldCheck className="text-race-volt mx-auto mb-3" size={48} />
            <h1 className="font-heading text-3xl tracking-tight text-race-volt">SANCTIONED & VERIFIED</h1>
            <p className="text-race-sub text-sm mt-2">This event was officially sanctioned and confirmed to have occurred.</p>
            <div className="mt-6 space-y-3 text-left">
              <Row label="Organizer" value={data.organizer} />
              <Row label="Event Type" value={data.event_type || "-"} />
              <Row label="Sanctioned Date" value={new Date(data.sanctioned_date).toLocaleString()} />
              <Row label="Verifier Signature" value={`${data.signature?.slice(0, 24)}…`} mono />
            </div>
          </div>
        ) : (
          <div className="text-center" data-testid="verify-inactive">
            <ShieldQuestion className="text-race-muted mx-auto mb-3" size={48} />
            <h1 className="font-heading text-3xl tracking-tight">NOT YET ACTIVATED</h1>
            <p className="text-race-sub text-sm mt-2">{data?.message || "This Domain Estate has not been activated."}</p>
          </div>
        )}
      </div>
    </div>
  );
}

const Row = ({ label, value, mono }) => (
  <div className="flex justify-between gap-4 border-b border-race-line/60 pb-2">
    <span className="overline text-race-sub">{label}</span>
    <span className={`text-race-txt text-sm text-right ${mono ? "font-mono break-all" : ""}`}>{value}</span>
  </div>
);
